import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';


import { HttpClientModule } from '@angular/common/http';
import { WebIntent } from '@awesome-cordova-plugins/web-intent/ngx';
import { IonicStorageModule } from '@ionic/storage';

// Native
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
import { TextToSpeechAdvanced } from '@awesome-cordova-plugins/text-to-speech-advanced/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
// import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
// import { FileTransfer, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { CameraPreview } from '@awesome-cordova-plugins/camera-preview/ngx';
import { BluetoothSerial } from '@awesome-cordova-plugins/bluetooth-serial/ngx';
// import { ImagePicker } from '@awesome-cordova-plugins/image-picker/ngx'
import { File } from '@awesome-cordova-plugins/file/ngx'
import { MediaCapture } from '@awesome-cordova-plugins/media-capture/ngx'
import { Media } from '@awesome-cordova-plugins/media/ngx'
import { StreamingMedia } from '@awesome-cordova-plugins/streaming-media/ngx'
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx'


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DxTemplateHost } from 'devextreme-angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import esMessages from 'devextreme/localization/messages/es.json';

import { locale, loadMessages } from 'devextreme/localization';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-419';
import localeEsExtra from '@angular/common/locales/extra/es-419';
import { PagesComponentsModule } from './components/pages/pages.component.module';

loadMessages(esMessages);
locale(navigator.language);
registerLocaleData(localeEs, 'es', localeEsExtra);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: '__wms_cicsa_db',
    }),
    HttpClientModule,
    PagesComponentsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    BluetoothSerial,
    AppVersion,
    NativeAudio,
    TextToSpeechAdvanced,
    Network,
    WebView,
    WebIntent,
    DxTemplateHost,
    // FileOpener,
    // FileTransfer,
    // FileTransferObject,
    Camera,
    CameraPreview,
    // ImagePicker,
    File,
    MediaCapture,
    Media,
    StreamingMedia,
    PhotoViewer
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
